var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import { BaseCheckpointModel, } from '../BaseCheckpointModel';
export class ReferencesCheckpoint extends BaseCheckpointModel {
    constructor(checkpoint) {
        var _a;
        super(checkpoint);
        this.referencePersons = checkpoint.referencePersons;
        (_a = this.referencePersons) === null || _a === void 0 ? void 0 : _a.map((education, index) => {
            education.id = `${index}_${new Date().getTime()}`;
        });
    }
}
__decorate([
    observable
], ReferencesCheckpoint.prototype, "referencePersons", void 0);
export default ReferencesCheckpoint;
